import React from 'react';
import PropTypes from 'prop-types';

const SpacerView = ({ data }) => {
  const size = data.size || 'm';
  return <div className={`ag-spacer ag-spacer--${size}`} aria-hidden="true" />;
};

SpacerView.propTypes = {
  data: PropTypes.shape({ size: PropTypes.string }).isRequired,
};

export default SpacerView;
